import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询副本列表
export const queryZones: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMetaZones', { ...state.zones, loading: true });
    const res: IPageData = await $http.post('/v1/data/ue/roominstance/pagelist', payload);
    commit('setMetaZones', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setMetaZones', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询副本详情
export const queryZoneDetail: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setZoneDetail', { ...state.detail, loading: true });
    const res = await $http.get(`/v1/ue/roominstance/${payload}/detail`);
    commit('setZoneDetail', { data: res });
  } catch (e) {
    commit('setZoneDetail', { data: null });
  }
};

// 更新控制项里地图
export const updateTrigger: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/ue/roominstance/updatetriggerinnermap', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 编辑副本
export const editZone: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/ue/roominstance/updateinstance', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除副本
export const deleteZone: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/ue/roominstance/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
